import { render, staticRenderFns } from "./cwpaylate.vue?vue&type=template&id=ee77aad6"
import script from "./cwpaylate.vue?vue&type=script&lang=js"
export * from "./cwpaylate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports